<div class="container-fluid pt-4 pb-5" [style.background-color]="secondaryColor">
  <div class="container">
      <p class="mb-3">
        <a [href]="'/home'" class="btn btn-xs text-light shadow-none align-middle px-1">
          <img src="./assets/images/arrow-left.svg" width="18px">
          Volver</a>
      </p>
      <h2 class="text-light mb-4">Biblioteca de Documentos</h2>
  </div>
</div>
<div class="container m-offset-5 mb-4">
  <div class="row">
    <div class="col-12">
      <div class="card p-3">
        <form action="#">
            <div class="row">
                <div class="col">
                <mdb-form-control>
                    <!--label mdbLabel class="form-label">Seleccione Tipo de Documento</label-->
                    <mdb-select placeholder="Seleccione Tipo de Documento" formControlName="TipoDocumento" (valueChange)="onTipoDocumentoSelected($event)">
                    <mdb-option *ngFor="let option of TipoDocumento" [value]="option.value">{{ option.label }}</mdb-option>
                    </mdb-select>
                </mdb-form-control>
                </div>
                <div class="col">
                <mdb-form-control>
                    <!--label mdbLabel class="form-label">Seleccione Detalle de Documento</label-->
                    <mdb-select placeholder="Seleccione Detalle de Documento" formControlName="DetalleTipoDocumento" (valueChange)="onChangeTipoDocumentoSelected($event)">
                    <mdb-option *ngFor="let option of DetalleTipoDocumento" [value]="option.value">{{ option.label }}</mdb-option>
                    </mdb-select>
                </mdb-form-control>
                </div>
                <div class="col">
                <mdb-chips>
                    <mdb-form-control
                    class="chips-input-wrapper chips-transition w-100"
                    [class.chips-padding]="tags.length > 0"
                    >
                    <!--label mdbLabel class="form-label">Ingrese: Código de Documento, Palabras Claves, Nombre de Documento</label-->
                    <mdb-chip *ngFor="let tag of tags" (deleted)="delete(tag)">
                        <span class="text-chip">{{ tag.name }}</span>
                        <i class="close fas fa-times" mdbChipDelete></i>
                    </mdb-chip>
                    <input
                        (keydown.enter)="onEnterPress()" 
                        mdbChipsInput
                        class="form-control chips-input"
                        (chipAdd)="add($event)"
                        placeholder="Código de Documento, Palabras Claves, Nombre de Documento"
                    />
                    </mdb-form-control>
                </mdb-chips>
                </div>
                <div class="col-2">
                <!--{{qty|json}} -->
                <button type="button"  (click)="loadData();" class="btn btn-primary shadow-none rounded-5 w-100" [disabled]="enableButton === false">Buscar</button>
                </div>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!--
<a
[routerLink]="['/pdf-viewer']"
[queryParams]="{ url: 'assets/pdfs/documento1.pdf' }"
target="_blank"
> ABRRRRRIR </a>-->

<div class="container">
    <p class="px-3" [style.color]="secondaryColor">Resultados de Búsqueda:</p>
    <div class="datatable table-editor">
        <table
            class="table datatable-table"
            mdbTable
            mdbTableSort
            #table="mdbTable"
            #sort="mdbTableSort"
            [dataSource]="dataSource"
            [pagination]="pagination"
            [sort]="sort"
            width="100%"
        >
            <thead class="datatable-header">
            <tr>
                <th
                *ngFor="let header of headers"
                [mdbTableSortHeader]="header.field"
                [disableSort]="header.disableSort"
                scope="col"
                class="bg-gris-02 py-2 align-middle th_3"
                style="white-space: normal;"
                >
                {{ header.label.replace("_", " ") | titlecase }}
                </th>
                <ng-container *ngIf="filas > 0">
                    <th scope="col" class="bg-gris-02">Ver Doc</th>
                </ng-container>
            </tr>
            </thead>
            <tbody class="datatable-body" *ngIf="filas == 0">
                <tr *ngIf="!loading && !busqueda">
                    <td colspan="5" class="p-0 pt-1">
                        <div class="px-2 bg-gris-01 py-5">
                            <p class="text-center mt-5">
                                <img width="150" class="opacity-50" src="./assets/images/search.svg" />
                            </p>
                            <p class="lead text-gris-02 text-center mb-5">
                                Seleccione Tipo, Detalle e ingrese Código de Documento, Palabras Claves o Nombre de Documento.
                            </p>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="loading && busqueda">
                    <td colspan="5" class="p-0 pt-1">
                        <div class="px-2 bg-gris-01 py-5 text-center">
                            <div width="150" class="spinner-border mt-5 opacity-50" role="status"></div>
                            <p class="lead text-gris-02 text-center mb-5">
                                Cargando resultados...
                            </p>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="!loading && busqueda">
                    <td colspan="5" class="p-0 pt-1">
                        <div class="px-2 bg-gris-01 py-5">
                            <p class="text-center mt-5">
                                <img width="150" class="opacity-50" src="./assets/images/folder.svg" />
                            </p>
                            <p class="lead text-gris-02 text-center mb-5">
                                No se encontraron registros.
                            </p>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody class="datatable-body" *ngIf="filas > 0">
                <tr
                    *ngFor="let data of table.data; let index = index"
                    scope="row"
                    [cdkTrapFocus]="editElementIndex === index"
                    [cdkTrapFocusAutoCapture]="editElementIndex === index"
                    [ngClass]="{ 'edited-row': editElementIndex === index }"
                >
                    <td style="min-width: 250px; max-width: 250px; white-space: normal;">
                        <ng-container>
                            <img src="./assets/images/pdf-download.svg" alt="PDF" width="24px">
                            {{ data.CODIGO_DOCUMENTO }}
                        </ng-container>
                    </td>
                    <td style="min-width: 250px; max-width: 250px; white-space: normal;">
                        <ng-container>
                            {{ data.NOMBRE_DOCUMENTO }}
                        </ng-container>
                    </td>
                    <td style="min-width: 250px; max-width: 250px; white-space: normal;">
                        <ng-container>
                            {{ data.NOMBRE_GERENCIA }}
                        </ng-container>
                    </td>
                    <!-- <td>
                        <ng-container>
                            {{ data.PALABRAS_CLAVES }}
                        </ng-container>
                    </td> -->
                    <td>
                    <!--ng-container>
                        <button
                        class="btn rounded-5"
                        (click)="openModalDetalle(data)"
                        >
                            <img width="14" class="opacity-50" src="./assets/images/eye.svg" />
                        </button>
                    </ng-container-->
                    <ng-container>
                        <button
                        
                        class="btn btn-rounded"
                        (click)="openModalPDF(data)"
                        >
                            <img width="14" class="opacity-50" src="./assets/images/file-text.svg" />
                        </button>
                    </ng-container>
                    <!--ng-container>
                        <a
                        
                        class="btn btn-rounded"
                        target="_blank"
                        >
                            <img width="12" class="opacity-50" src="./assets/images/file-text.svg" />
                        </a>
                    </ng-container>
                    <ng-container>
                        <button
                        class="me-2 m-0 p-0 shadow-0 btn btn-lg text-dark save-button"
                        (click)="editElementIndex = -1"
                        >
                        <i class="fa fa-check"></i>
                        </button>
                        <button
                        class="m-0 p-0 shadow-0 btn btn-lg text-dark discard-button"
                        (click)="onDiscardEdit(index)"
                        >
                        <i class="fa fa-ban"></i>
                        </button>
                    </ng-container-->
                    </td>
                </tr>
            </tbody>
        </table>

        <mdb-table-pagination
            #pagination
            rowsPerPageText = 'Registros por Pagina'
            ofText = 'de'
            [entries]="10"
            [disabled]="addRow || editElementIndex !== -1 || dataDocumentService.loading"
        ></mdb-table-pagination>
    </div>
</div>

<div class="modal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-mdb-ripple-init data-mdb-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <p>Modal body text goes here.</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-mdb-ripple-init data-mdb-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-mdb-ripple-init>Save changes</button>
        </div>
        </div>
    </div>
</div>

<mdb-loading [show]="loadingFull" [fullscreen]="true">
    <div class="loading-spinner">
        <div class="spinner-border loading-icon" role="status"></div>
        <span class="loading-text">Cargando datos...</span>
    </div>
</mdb-loading>